/** 표시용 포매터. 계산은 여기 모아 두고 컴포넌트는 배치만 한다. */

export function since(ms: number | null | undefined): string {
  if (!ms) return "-";
  const s = Math.max(0, Math.round((Date.now() - ms) / 1000));
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  if (s < 86_400) return `${Math.floor(s / 3600)}h`;
  return `${Math.floor(s / 86_400)}d`;
}

export function until(ms: number): string {
  const s = Math.max(0, Math.round((ms - Date.now()) / 1000));
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.floor(s / 60)}m`;
  if (s < 86_400) return `${Math.floor(s / 3600)}h`;
  return `${Math.floor(s / 86_400)}d`;
}

export const labelText = (o: Record<string, string> | undefined): string =>
  Object.entries(o ?? {})
    .map(([k, v]) => `${k}=${v}`)
    .join(",") || "-";

/**
 * pd-balanced 서울 실단가 (Billing 카탈로그 조회값). 다른 StorageClass·리전이면 어림이다 —
 * 컨트롤러는 StorageClass 이름만 알고 단가는 모르므로 여기 상수로 둔다.
 */
export const USD_PER_GIB_MONTH = 0.13;

export const volumeCost = (gib: number): string => `$${(gib * USD_PER_GIB_MONTH).toFixed(2)}`;

/** 절대 시각 (목록·상세에서 "언제"를 정확히 봐야 할 때). */
export const at = (ms: number | null | undefined): string =>
  ms ? new Date(ms).toLocaleString("ko-KR", { hour12: false }) : "-";

/**
 * 시각 목록을 최근 `hours` 시간 동안의 버킷 수로 접는다. 생성 추이 차트의 입력.
 *
 * 이게 우리가 시계열 없이 추이를 그리는 방법이다 — 지금 살아 있는 리소스의 생성 시각은
 * 조회로 알 수 있으므로 정직한 히스토그램이 된다. 단 **이미 회수된 것은 안 보인다**
 * (그래서 차트 제목이 "생성 추이"가 아니라 "살아있는 것의 생성 시각"에 가깝다).
 */
export function buckets(times: number[], hours: number, slots: number): number[] {
  const now = Date.now();
  const span = hours * 3_600_000;
  const out = new Array<number>(slots).fill(0);
  for (const t of times) {
    const age = now - t;
    if (age < 0 || age > span) continue;
    const i = Math.min(slots - 1, Math.floor(((span - age) / span) * slots));
    out[i] = (out[i] ?? 0) + 1;
  }
  return out;
}
